<template>
  <div class="d-flex">
    <div class="d-flex flex-column justify-content-center pr-3" v-if="icon">
      <icon :name="icon" size="22"/>
    </div>
    <div class="w-100">
      <h5 class="mb-0">{{heading}}</h5>
      <p class="mb-0" v-newlines>{{text}}</p>
    </div>
    <div class="d-flex flex-column justify-content-center" v-if="disclosure">
      <p class="mb-0">&gt;</p>
    </div>
  </div>
</template>


<script>
import Icon from '@/components/Icon'

export default {
  name: 'ListItem',
  props: ['icon', 'heading', 'text', 'disclosure'],
  components: { icon: Icon },
  directives: {
    newlines: {
      inserted (el) {
        // simplified example,
        // works only for nodes without any child elements
        el.innerHTML = el.textContent.replace(/\n/g, '<br>')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListItem.vue